import { styled } from '@mui/material/styles';

const StyledHeaderPricing = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${(props) => (props.isNewOverview ? '14px 24px' : '12px 0px')};
  border-bottom: ${(props) =>
    props.isNewOverview
      ? '1px solid rgba(30, 22, 78, 0.16)'
      : '1px solid #1e164e29'};
  height: ${(props) => (props.isNewOverview ? '65px' : '80px')};
  box-sizing: border-box;
  background-color: ${(props) =>
    props.isNewOverview ? '#ffffff' : 'transparent'};
  ${(props) =>
    props.isNewOverview &&
    `
    position: sticky;
    top: 0;
    z-index: 100;
  `}

  .project-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1;
    min-width: 0;
  }

  .subtitle-pricing {
    color: rgba(28, 28, 30, 0.64);
  }

  .btn-action {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }

  /* NewPackageInfoV3 relies on its host for layout, as in the other page headers. */
  .wallet-package {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    cursor: pointer;
  }
  @media only screen and (max-width: 768px) {
    padding: ${(props) => (props.isNewOverview ? '14px 16px' : '12px 0px')};
  }

  @media only screen and (max-width: 600px) {
    position: static;
    flex-direction: column;
    align-items: flex-center;
    gap: 16px;
    height: auto;
    padding: auto;
    background-color: transparent;
    border-bottom: none;
    .project-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      flex: 1;
      min-width: 0;
      margin-top: 12px;
    }
    .title-pricing-model {
      font-size: ${(props) => (props.isNewOverview ? '20px' : '32px')};
      font-weight: 700;
      line-height: ${(props) => (props.isNewOverview ? '28px' : '38px')};
    }
    .btn-action {
      gap: 10px;
      align-items: center;
      display: flex;
      justify-content: center;
      align-self: center;
    }
  }
`;

export { StyledHeaderPricing };
